<template>
  <v-app>
    <Menu />
    <Header/>
    <v-main>
      <router-view />
    </v-main>
    <Footer />
  </v-app>
</template>
<script>
import Menu from "./components/Menu"
import Header from "./components/Header"
import Footer from "./components/Footer"
export default {
  components:{Menu,Header, Footer},
};
</script>
